"use client";
import { createTheme } from "@mui/material";
import { FontLineHeightLg, FontLineHeightMd, FontLineHeightSm, TypeFontB3LgLineHeight, TypeFontB3LgSize, TypeFontB3XsLineHeight, TypeFontB3XsSize, TypeFontB2LgLineHeight, TypeFontB2LgSize, TypeFontB2XsLineHeight, TypeFontB2XsSize, TypeFontB1LgLineHeight, TypeFontB1LgSize, TypeFontB1XsLineHeight, TypeFontB1XsSize, TypeFontBodyCopyMobileLineHeight, TypeFontBodyCopyMobileSize, TypeFontL2LgLineHeight, TypeFontL2LgSize, TypeFontL2XsLineHeight, TypeFontL2XsSize, TypeFontL1LgLineHeight, TypeFontL1LgSize, TypeFontL1XsLineHeight, TypeFontL1XsSize, TypeFontT7MobileLineHeight, TypeFontT7MobileSize, TypeFontT6MobileLineHeight, TypeFontT6MobileSize, TypeFontT5MobileLineHeight, TypeFontT5MobileSize, TypeFontT4LgLineHeight, TypeFontT4LgSize, TypeFontT4XsLineHeight, TypeFontT4XsSize, TypeFontT4MobileLineHeight, TypeFontT4MobileSize, TypeFontT3LgLineHeight, TypeFontT3LgSize, TypeFontT3XsLineHeight, TypeFontT3XsSize, TypeFontT3DesktopLineHeight, TypeFontT3DesktopSize, TypeFontT3MobileLineHeight, TypeFontT3MobileSize, TypeFontT2LgLineHeight, TypeFontT2LgSize, TypeFontT2XsLineHeight, TypeFontT2XsSize, TypeFontT2DesktopLineHeight, TypeFontT2DesktopSize, TypeFontT2MobileLineHeight, TypeFontT2MobileSize, TypeFontT1LgLineHeight, TypeFontT1LgSize, TypeFontT1XsLineHeight, TypeFontT1XsSize, TypeFontT1DesktopLineHeight, TypeFontT1DesktopSize, TypeFontT1MobileLineHeight, TypeFontT1MobileSize, SpaceXxs, SpaceXs, SpaceSm, SpaceMd, SpaceLg, SpaceXl, SpaceXxl, SpaceXxxl, SizeBorderWidthThick, SizeBorderWidthMedium, SizeBorderWidthThin, RadiusMd, RadiusSm, ColorGreen500, ColorGray300, ColorBlue500, ColorGray900, ColorWhite, ColorTextLink, ColorTextCaution, ColorTextSuccess, ColorTextError, ColorTextLight, ColorTextMedium, ColorTextDefault, ColorCostcoBlue, ColorCostcoRed, ColorOrange, ColorBlue700, ColorBlue600, ColorBlue100, ColorGreen700, ColorGreen200, ColorGreen100, ColorGray800, ColorGray700, ColorGray600, ColorGray500, ColorGray400, ColorGray200, ColorGray150, ColorGray100, ColorBlack, ColorYellow200, ColorYellow100, ColorRed500, ColorRed100, FontWeightBold, FontSize200, FontWeightDefault, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
const MuiCostcoTheme = createTheme({
  palette: {
    primary: {
      main: ColorBlue500
    },
    secondary: {
      main: ColorBlue500
    },
    error: {
      main: ColorTextError
    },
    background: {
      default: ColorWhite,
      paper: ColorWhite
    },
    red: {
      100: ColorRed100,
      500: ColorRed500
    },
    yellow: {
      100: ColorYellow100,
      200: ColorYellow200
    },
    white: ColorWhite,
    black: ColorBlack,
    gray: {
      100: ColorGray100,
      150: ColorGray150,
      200: ColorGray200,
      300: ColorGray300,
      400: ColorGray400,
      500: ColorGray500,
      600: ColorGray600,
      700: ColorGray700,
      800: ColorGray800,
      900: ColorGray900
    },
    green: {
      100: ColorGreen100,
      200: ColorGreen200,
      500: ColorGreen500,
      700: ColorGreen700
    },
    blue: {
      100: ColorBlue100,
      500: ColorBlue500,
      600: ColorBlue600,
      700: ColorBlue700
    },
    orange: ColorOrange,
    costco: {
      red: ColorCostcoRed,
      blue: ColorCostcoBlue
    },
    text: {
      primary: ColorTextDefault,
      secondary: ColorTextMedium,
      default: ColorTextDefault,
      medium: ColorTextMedium,
      light: ColorTextLight,
      error: ColorTextError,
      success: ColorTextSuccess,
      caution: ColorTextCaution,
      link: ColorTextLink,
      white: ColorWhite
    },
    icon: {
      default: ColorGray900,
      primary: ColorBlue500,
      secondary: ColorGray300,
      success: ColorGreen500
    }
  },
  radii: {
    sm: RadiusSm,
    md: RadiusMd
  },
  borderWidth: {
    thin: SizeBorderWidthThin,
    medium: SizeBorderWidthMedium,
    thick: SizeBorderWidthThick
  },
  // TODO units from tokens, either need to update transform on style-dictionary or configure this to be unitless and use what's provided by material-ui
  // TODO keys for breakpoints
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1024,
      xl: 1440
    }
  },
  spacing: [
    0,
    SpaceXxs,
    SpaceXs,
    SpaceSm,
    SpaceMd,
    SpaceLg,
    SpaceXl,
    SpaceXxl,
    SpaceXxxl
  ],
  typography: {
    fontFamily: [
      "TestBetaFont1",
      "TestBetaFont2",
      "TestBetaFont3",
      "Helvetica Neue",
      "'Helvetica Neue LT Pro'",
      "Helvetica",
      "Arial",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "sans-serif"
    ].join(","),
    fontWeightLight: void 0,
    fontWeightRegular: 400,
    fontWeightMedium: void 0,
    fontWeightBold: 700,
    t1: {
      fontWeight: 400,
      fontSize: TypeFontT1MobileSize,
      lineHeight: TypeFontT1MobileLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT1DesktopSize,
        lineHeight: TypeFontT1DesktopLineHeight
      }
    },
    "t1-v2": {
      fontWeight: 400,
      fontSize: TypeFontT1XsSize,
      lineHeight: TypeFontT1XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT1LgSize,
        lineHeight: TypeFontT1LgLineHeight
      }
    },
    t2: {
      fontWeight: 400,
      fontSize: TypeFontT2MobileSize,
      lineHeight: TypeFontT2MobileLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT2DesktopSize,
        lineHeight: TypeFontT2DesktopLineHeight
      }
    },
    "t2-v2": {
      fontWeight: 400,
      fontSize: TypeFontT2XsSize,
      lineHeight: TypeFontT2XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT2LgSize,
        lineHeight: TypeFontT2LgLineHeight
      }
    },
    t3: {
      fontWeight: 400,
      fontSize: TypeFontT3MobileSize,
      lineHeight: TypeFontT3MobileLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT3DesktopSize,
        lineHeight: TypeFontT3DesktopLineHeight
      }
    },
    "t3-v2": {
      fontWeight: 400,
      fontSize: TypeFontT3XsSize,
      lineHeight: TypeFontT3XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT3LgSize,
        lineHeight: TypeFontT3LgLineHeight
      }
    },
    t4: {
      fontWeight: 400,
      fontSize: TypeFontT4MobileSize,
      lineHeight: TypeFontT4MobileLineHeight
    },
    "t4-v2": {
      fontWeight: 400,
      fontSize: TypeFontT4XsSize,
      lineHeight: TypeFontT4XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontT4LgSize,
        lineHeight: TypeFontT4LgLineHeight
      }
    },
    t5: {
      fontWeight: 400,
      fontSize: TypeFontT5MobileSize,
      lineHeight: TypeFontT5MobileLineHeight
    },
    t6: {
      fontWeight: 400,
      fontSize: TypeFontT6MobileSize,
      lineHeight: TypeFontT6MobileLineHeight
    },
    t7: {
      fontWeight: 400,
      fontSize: TypeFontT7MobileSize,
      lineHeight: TypeFontT7MobileLineHeight
    },
    l1: {
      fontWeight: 400,
      fontSize: TypeFontL1XsSize,
      lineHeight: TypeFontL1XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontL1LgSize,
        lineHeight: TypeFontL1LgLineHeight
      }
    },
    l2: {
      fontWeight: 400,
      fontSize: TypeFontL2XsSize,
      lineHeight: TypeFontL2XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontL2LgSize,
        lineHeight: TypeFontL2LgLineHeight
      }
    },
    bodyCopy: {
      fontWeight: 400,
      fontSize: TypeFontBodyCopyMobileSize,
      lineHeight: TypeFontBodyCopyMobileLineHeight
    },
    b1: {
      fontWeight: 400,
      fontSize: TypeFontB1XsSize,
      lineHeight: TypeFontB1XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontB1LgSize,
        lineHeight: TypeFontB1LgLineHeight
      }
    },
    b2: {
      fontWeight: 400,
      fontSize: TypeFontB2XsSize,
      lineHeight: TypeFontB2XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontB2LgSize,
        lineHeight: TypeFontB2LgLineHeight
      }
    },
    b3: {
      fontWeight: 400,
      fontSize: TypeFontB3XsSize,
      lineHeight: TypeFontB3XsLineHeight,
      "@media (min-width: 768px)": {
        fontSize: TypeFontB3LgSize,
        lineHeight: TypeFontB3LgLineHeight
      }
    },
    lineHeights: {
      sm: FontLineHeightSm,
      md: FontLineHeightMd,
      lg: FontLineHeightLg
    }
  }
});
MuiCostcoTheme.components = {
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: FontSize300,
        fontStyle: "normal",
        fontWeight: FontWeightDefault,
        textTransform: "inherit",
        textAlign: "center",
        height: "40px",
        borderRadius: RadiusMd,
        paddingLeft: SpaceMd,
        paddingRight: SpaceMd
      }
    },
    variants: [
      {
        props: { variant: "primary" },
        style: {
          color: ColorWhite,
          backgroundColor: ColorCostcoBlue,
          "&:hover": {
            backgroundColor: "#004C8A"
          },
          "&:focus": {
            backgroundColor: "#004C8A"
          },
          "&.Mui-disabled": {
            color: ColorWhite
          }
        }
      },
      {
        props: { variant: "primary-alternate" },
        style: {
          color: ColorWhite,
          backgroundColor: ColorGreen500,
          "&:hover": {
            backgroundColor: ColorGreen700
          },
          "&:focus": {
            backgroundColor: ColorGreen700
          },
          "&.Mui-disabled": {
            color: ColorWhite
          }
        }
      },
      {
        props: { variant: "secondary" },
        style: {
          color: ColorCostcoBlue,
          backgroundColor: ColorWhite,
          borderWidth: SizeBorderWidthThin,
          borderStyle: "solid",
          borderColor: ColorCostcoBlue,
          "&:hover": {
            backgroundColor: ColorGray200
          },
          "&:focus": {
            backgroundColor: ColorGray200
          },
          "&.Mui-disabled": {
            color: ColorCostcoBlue
          }
        }
      },
      {
        props: { variant: "tertiary" },
        style: {
          color: ColorCostcoBlue,
          backgroundColor: "transparent",
          borderStyle: "none",
          "&:hover": {
            backgroundColor: ColorGray150
          },
          "&:focus": {
            backgroundColor: ColorGray150
          },
          "&.Mui-disabled": {
            color: ColorCostcoBlue
          }
        }
      },
      {
        props: { variant: "tertiary-dark-bg" },
        style: {
          color: ColorWhite,
          backgroundColor: "transparent",
          borderStyle: "none",
          "&:hover": {
            color: ColorCostcoBlue,
            backgroundColor: ColorGray150
          },
          "&:focus": {
            color: ColorCostcoBlue,
            backgroundColor: ColorGray150
          },
          "&.Mui-disabled": {
            color: ColorWhite
          }
        }
      },
      {
        props: { variant: "ghost" },
        style: {
          color: ColorCostcoBlue,
          backgroundColor: "transparent",
          borderWidth: SizeBorderWidthThin,
          borderStyle: "solid",
          borderColor: ColorCostcoBlue,
          "&:hover": {
            backgroundColor: ColorGray150
          },
          "&:focus": {
            backgroundColor: ColorGray150
          },
          "&.Mui-disabled": {
            color: ColorCostcoBlue
          }
        }
      },
      {
        props: { variant: "ghost-dark-bg" },
        style: {
          color: ColorWhite,
          backgroundColor: "transparent",
          borderWidth: SizeBorderWidthThin,
          borderStyle: "solid",
          borderColor: ColorWhite,
          "&:hover": {
            color: ColorCostcoBlue,
            backgroundColor: ColorGray150
          },
          "&:focus": {
            color: ColorCostcoBlue,
            backgroundColor: ColorGray150
          },
          "&.Mui-disabled": {
            color: ColorWhite
          }
        }
      },
      {
        props: { variant: "text-button" },
        style: {
          fontSize: "14px",
          color: ColorTextLink,
          border: "none",
          padding: 0,
          margin: 0,
          cursor: "pointer",
          textDecoration: "none",
          backgroundColor: "transparent",
          height: "auto",
          "&:hover": {
            textDecoration: "underline",
            backgroundColor: "transparent"
          },
          "&:focus": {
            textDecoration: "underline",
            backgroundColor: "transparent"
          },
          "&.Mui-disabled": {
            color: ColorTextLink
          }
        }
      },
      {
        props: { variant: "text-button-alternate" },
        style: {
          fontSize: FontSize200,
          color: ColorTextDefault,
          border: `1px solid ${ColorGray800}`,
          borderRadius: SpaceXxs,
          padding: SpaceSm,
          minWidth: "53px",
          margin: 0,
          cursor: "pointer",
          textDecoration: "none",
          backgroundColor: ColorWhite,
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          height: "auto",
          "&:hover": {
            border: `1px solid ${ColorGray800}`,
            backgroundColor: ColorWhite,
            boxShadow: `0px 0.5px 3px 0px rgba(0, 0, 0, 0.50)`
          }
        }
      },
      {
        props: { variant: "text-button-out-of-stock" },
        style: {
          fontSize: FontSize200,
          color: ColorTextDefault,
          borderRadius: SpaceXxs,
          padding: SpaceSm,
          minWidth: "53px",
          margin: 0,
          cursor: "pointer",
          textDecoration: "none",
          backgroundColor: ColorWhite,
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          height: "auto",
          backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%235F5F5FFF' stroke-width='2' stroke-dasharray='4%2c8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
          borderStyle: "none",
          "::before": {
            background: `linear-gradient(to top left,
              rgba(0,0,0,0) 0%,
              rgba(0,0,0,0) calc(50% - 0.8px),
              rgba(0,0,0,1) 50%,
              rgba(0,0,0,0) calc(50% + 0.8px),
              rgba(0,0,0,0) 100%)`,
            content: "''",
            height: "100%",
            left: 0,
            position: "absolute",
            top: 0,
            width: "100%",
            zIndex: 1
          },
          "&:hover": {
            outline: `1px solid ${ColorGray800}`,
            backgroundImage: "none",
            boxShadow: `0px 0.5px 2px 0px rgba(0, 0, 0, 0.50)`
          }
        }
      }
    ]
  },
  MuiLink: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...ownerState.color === "primary" && {
          color: ColorTextLink
        }
      })
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        ...MuiCostcoTheme.typography.t7,
        marginTop: SpaceXxs,
        fontWeight: FontWeightBold
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
      // No more ripple!
    },
    styleOverrides: {
      root: {
        "&.Mui-focusVisible": {
          outlineOffset: "2px",
          outline: "2px solid -webkit-focus-ring-color",
          // @ts-expect-error needed for outline in mozilla
          outline: "2px solid Highlight"
        }
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      a: {
        color: ColorTextLink
      }
    }
  },
  MuiGrid2: {
    defaultProps: {
      columnSpacing: { sm: SpaceMd, md: SpaceLg }
    }
  },
  MuiGrid: {
    defaultProps: {
      columnSpacing: { sm: SpaceMd, md: SpaceLg }
    }
  }
};
export {
  MuiCostcoTheme
};
